import { allowedExtensions } from '@bybeam/platform-lib/verification/allowedExtensions';

export function validateFileName(rawDocuments: FileList) {
  let errorMessage = undefined;
  for (const document of Array.from(rawDocuments)) {
    const originalFilename = document.name ?? '';
    if (!allowedExtensions.test(originalFilename)) {
      errorMessage = 'Only images, pdfs, word documents, or excel files are allowed.';
      break;
    }
  }
  return errorMessage;
}
